<template>
  <v-app>
    <v-content>
      <div id="manipulative_viewer" class="manipulative_viewer">
          <div id="manip_div" class="manipulative_container">
            <v-layout wrap justify-center align-center v-if="initializing" pa-0>
              <v-flex xs12 id="buffer_cell" style="height: 240px">
              </v-flex>
              <v-flex xs12 text-xs-center title>
                {{ loadMessage }}
              </v-flex>
              <v-flex xs6>
                <v-progress-linear
                  color="secondary"
                  :height="40"
                  v-model="loadProgress">
                </v-progress-linear>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center align-center v-if="initError" py-3>
              <v-flex xs12 error-block pa-5 text-xs-center>
                <p class="headline secondary--text mb-3">Sorry, could not load the manipulative.</p>
                <p class="subheading primary--text mb-3">This feature may not be supported by older browsers or operating systems. Please try again on a different browser or operating system. Contact support@brainingcamp.com if the problem continues.</p>
                <p class="caption red--text">
                  {{ initError }}
                </p>
              </v-flex>
            </v-layout>
          </div>
        </div>

        <v-dialog v-model="invalidCodeError" width="550">
          <v-layout wrap white pa-3>
            <v-flex xs12 headline text-xs-center primary--text pa-3>
              Not a recognized code. Please try again.
            </v-flex>
          </v-layout>
        </v-dialog>

        <v-dialog v-model="invalidFileError" width="550">
          <v-layout wrap white pa-3>
            <v-flex xs12 headline text-xs-center primary--text pa-3>
              Could not load. Please try again.
            </v-flex>
          </v-layout>
        </v-dialog>

        <v-dialog v-model="fileLoadError" width="550">
          <v-layout wrap white pa-3>
            <v-flex xs12 headline text-xs-center primary--text pa-3>
              There was a problem loading the file. The error has been sent to our support team.
            </v-flex>
          </v-layout>
        </v-dialog>
    </v-content>
  </v-app>
</template>

<script>
/* eslint-disable */
import {debounce, find} from 'lodash'
import manips from '@/data/manips.js'
import ShareService from '@/services/ShareService'
import AuthorizeService from '@/services/AuthorizeService'

const kSIDEBAR_WIDTH = 0;

export default {
  static: {
    app : null
  },
  data: function () {
    return {
      initializing: false,
      fileDimensions: null,
      loadMessage: '',
      loadProgress:0,
      config: null,
      initError: null,
      invalidCodeError: false,
      invalidFileError: null,
      fileLoadError: false
    }
  },
  methods: {
    getScrollbarWidth: function () {
      try {
        var tw = window.innerWidth - kSIDEBAR_WIDTH;
        var cw = document.body.clientWidth - kSIDEBAR_WIDTH;

        return tw - cw;
      } catch (err) {
        return 0;
      }
    },
    resizer: debounce(function () {
      const app = this.$options.static.app
      var sbw = this.getScrollbarWidth();
      var canvasWidth = 1024;
      var canvasHeight = 768;
      var containerWidth = window.innerWidth - kSIDEBAR_WIDTH - sbw - 2;
      var containerHeight = window.innerHeight;

      if (canvasWidth > containerWidth || canvasHeight > containerHeight) {
        // when resizing the canvas to fit the container, apply padding when calculating the target ratio
        const ratio = Math.min(containerWidth / canvasWidth, containerHeight / canvasHeight);
        const newDimensions = { width: canvasWidth * ratio, height: canvasHeight * ratio };
        
        var div = app.rootDiv;
        app.canvas.width = canvasWidth;
        app.canvas.height = canvasHeight;

        //redraw
        app.redraw();

        // apply the scaling to fit it into the view
        div.style.marginLeft = "0";
        div.style.marginTop = "0";
        div.style.transform = `scale(${ratio})`;
      } else {
        // resize based on the window size
        var w = window.innerWidth - kSIDEBAR_WIDTH - sbw - 2;
        var h = window.innerHeight;
        var div = app.rootDiv;
        //set dimensions
        div.style.transform = '';
        div.style.width = w + "px";
        div.style.height = h + "px";
        app.canvas.width = w;
        app.canvas.height = h;

        //redraw
        app.redraw();
      }
    }, 32)
  },
  mounted: async function() {
    this.fileDimensions = {width: 1024, height: 768};
    
    this.initializing = true;
    this.loadProgress = 0;
    this.loadMessage = 'Initializing ...';

    const m_id = this.$route.query.m;
    const shareCode = this.$route.query.c;
    // setup geometry
    var sbw = this.getScrollbarWidth();
    var width = window.innerWidth - kSIDEBAR_WIDTH - sbw - 2;
    var height = window.innerHeight;

    let appletInstance = new bcm.BcmApplet('manip_div');;
    let options = {
        appId: m_id,
        width: width,
        height: height,
        state: null,
        enableKeyboardListeners: true
    };
    if (m_id) {
      // load blank manipulative

      this.config = find(manips, {'id': m_id});
      this.loadProgress = 30;
      this.loadMessage = 'Setting Up ...'
      
      try {
        await appletInstance.load(options.appId, options);
      } catch (err) {
        console.error(err);
        // display a unable to initialize error (most likely outdated browser)
        this.initError = err;
      }

      if (this.initError) {
        this.initializing = false;
        return;
      }

      // create manip instance
      this.loadProgress = 50;
      this.loadMessage = 'Loading Content ...';
    } else {
      this.initError = 'Invalid configuration.';
    }

    // setup the resizer
    window.addEventListener("resize", this.resizer);

    this.$options.static.app = appletInstance;

    appletInstance.canvas.style = "border: 1px solid black"

    // update viewer
    this.loadProgress = 100;
    this.loadMessage = 'Done!';
    
    this.initializing = false;

    // make sure there is no scrolling and that the viewer matches the canvas dimensions
    this.resizer();

    // try {
    //   const authResult = await AuthorizeService.authorize(this.config.id)
    // } catch (err) {
    //   console.log(err)
    // }
  },
  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener("resize", this.resizer);
    if (app) {
        app.unload();
        this.$options.static.app = null;
    }
  }
}
</script>

<style scoped>

body {
  overflow: hidden;
}

.hide {
  display: none;
}

.show {
  display: block;
}

.error-block {
  width: 100%;
  height: 100%;
  grid-area: viewer;
  text-align: center;
}

.manipulative_viewer {
  overflow: hidden;
  background: #cecece;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 0px auto;
  grid-template-areas: "menu  viewer";
}

.menu_sidebar {
  grid-area: menu;
  background: #f3f3f3;
  width: 60px;
}

.menu_sidebar .item {
  text-align: center;
  margin: 16px auto;
  display: block;
}

.menu_sidebar img:first-child {
  margin-top: 4px;
}

.menu_icon {
  width: 34px;
  cursor: pointer;
}

.menu_sidebar .split {
  width: 100%;
  height: 1px;
  background: #ebebeb;
}

.manipulative_container {
  grid-area: viewer;
  transform-origin: top left;
}

.v-overlay--active:before {
  opacity: 0.98;
}
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100%;
}

.copy-input-style {
  position: absolute;
  left: -100;
}
</style>
